import React, {Component} from 'react';
import {getFormSyncErrors, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';
import { Field, change } from 'redux-form';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { SIGN_UP_FORM_ID, REDIRECT_SUFFIX, NETWORK } from '../../framework/App/AppConstants';
import Email from '../Email/Email';
import Captcha from '../Captcha/Captcha';
import Password from '../Password/Password';
import TermsCheckBox from '../PPTerms/PPTerms';
import PPMarketingTerms from '../PPMarketingTerms/PPMarketingTerms';
import Button, { BUTTON_STYLE } from '../../shared-components/Button/Button';
import _ from 'lodash';
import { formatMessage } from '../../framework/components/CurrentLocale/CurrentLocale';
import { redirectFlowAction } from '../../framework/store/RedirectFlow/RedirectFlowActions';
import { spinnerOpen } from '../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { handleSubmitFail } from '../FormElement/FormElementUtils';
import './newCustomerForm.less';
import PageHeaderText from '../Typography/PageHeaderText';
import axios from 'axios';
import { EMAIL_AVAILABILITY_CHECK_API } from '../../US/config/apiEndpoints';

const LOCALE_PREFIX = 'components/NewCustomerForm/newCustomerForm';

export class NewCustomerForm extends Component {
    static propTypes = {
        intl: intlShape.isRequired,

        // http://redux-form.com/6.7.0/docs/api/ReduxForm.md/#-onsubmit-function-optional-
        // Injected into decorated reduxForm() component; callback after successful validation
        handleSubmit: PropTypes.func.isRequired,

        showCaptcha: PropTypes.bool,
        showTickMark:PropTypes.bool,
        loginLink: PropTypes.string.isRequired,
        redirectToLogin: PropTypes.func,

        // Passed in props
        initialValues: PropTypes.object, // Passed into redux-form HOC
        termsCheckboxLabel: PropTypes.element.isRequired,
        termsMarketingCheckboxLabel: PropTypes.element,
        _csrf: PropTypes.string
    };

    handleRedirectToLogin = event => {
        const { redirectToLogin, loginLink } = this.props;
        event.preventDefault();
        redirectToLogin(loginLink);
    };

    render() {
        const {
            handleSubmit,
            showCaptcha,
            showTickMark,
            termsCheckboxLabel,
            termsMarketingCheckboxLabel,
            _csrf
        } = this.props;

        return (
            <div>
                <PageHeaderText>
                    <FormattedMessage id={`${LOCALE_PREFIX}.createAccount-header`} />
                </PageHeaderText>
                <div className="vx_row">
                    <p className="vx_col-md-12 vx_text-legal"><FormattedMessage id={`${LOCALE_PREFIX}.createAccount-redirectToLogin`} />
                        <Button data-automation-id="login" btnStyle={BUTTON_STYLE.LINK} onClick={this.handleRedirectToLogin} className="accessible-link" name="login-link">
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.login`}
                            />
                        </Button>
                    </p>
                    <p className="vx_col-md-12 vx_text-legal"><FormattedMessage id={`${LOCALE_PREFIX}.createAccount-subHeader`} /></p>

                    <form id="create-account-form" onSubmit={handleSubmit} >
                        <Field component="input" type="hidden" id="_csrf" name="_csrf" value={_csrf} />
                        <Email />
                        <Password showTickMark={showTickMark} />
                        {termsMarketingCheckboxLabel && <PPMarketingTerms termsCheckboxLabel={termsMarketingCheckboxLabel} /> }
                        <TermsCheckBox termsCheckboxLabel={termsCheckboxLabel} />
                        {showCaptcha && <Captcha /> }
                    </form>
                </div>
            </div>
        );
    }
}

export const validate = values => {
    const id = `${LOCALE_PREFIX}.PASSWORD_CONFIRM_MISMATCH`;
    const msg = formatMessage({id});
    if (values.password !== values.confirmPassword) {
        return {
            confirmPassword: {
                msg,
                className: 'hasError'
            }
        };
    } else {
        return;
    }
};

export const asyncValidate = (values) => {
    const id = `${LOCALE_PREFIX}.email-already-exists`;
    const msg = formatMessage({id});

    return axios
        .request({
            url: EMAIL_AVAILABILITY_CHECK_API,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': values._csrf
            },
            data: {
                email: values.email
            }
        })
        .then(response => {
            if (!_.get(response, 'data.isEmailAvailable')) {
                return {
                    email: {
                        msg,
                        className: 'hasError emailUnavailableError'
                    }
                };
            }
        })
        .catch(error => {
            capeLog && capeLog('response:error, NewCustomerForm,' + (error && error.message));
        });
};

// We are overwriting the default behaviour for shouldAsyncValidate as we don't want async validation to happen on
// submit because the onblur email validation was causing delays in the appearance of our "submit spinner"
// which lead to a confusing user experience.
// If anyone adds additional async validation, please re-test loading email onblur validation on slow connection,
// and make sure the submit/spinnner behavior is a good user experience.
export const shouldAsyncValidate = (params) => {

    const trigger = params.trigger;
    const syncValidationPasses = params.syncValidationPasses;

    if (!syncValidationPasses) {
        return false;
    }

    switch (trigger) {
        case 'blur':
            return true;
        case 'submit':
            return false;
        default:
            return false;
    }
};

export const mapStateToProps = state => ({
    showTickMark:_.isEmpty(_.get(getFormSyncErrors(SIGN_UP_FORM_ID)(state), 'confirmPassword'), false),
    showCaptcha:_.get(state, 'serverData.showCaptcha', false),
    loginLink: REDIRECT_SUFFIX.LOGIN_REDIRECT,
    _csrf: _.get(state, 'serverData._csrf'),
    initialValues: {_csrf: _.get(state, 'serverData._csrf')}
});

export const mapDispatchToProps = dispatch => ({
    redirectToLogin(loginLink) {
        dispatch(spinnerOpen());
        dispatch(redirectFlowAction(loginLink));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: SIGN_UP_FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true,
        validate,
        asyncValidate,
        shouldAsyncValidate,
        asyncBlurFields: ['email']
    })(NewCustomerForm)
));
